/* @ngInject */
const icons = (
  accountIcons,
  wagonIcons,
  areaIcons,
  movementIcons,
  railwayIcons,
  contactIcons,
  dispatchIcons,
  ownerIcons,
  trainIcons,
  saleIcons,
  axletreeIcons,
  pieceIcons,
  sterileIcons,
  settingIcons,
  invoicingIcons,
  commandeIcons,
) => {
  const self = {}

  self.account = accountIcons
  self.wagon = wagonIcons
  self.movement = movementIcons
  self.area = areaIcons
  self.railway = railwayIcons
  self.contact = contactIcons
  self.owner = ownerIcons
  self.dispatch = dispatchIcons
  self.train = trainIcons
  self.commande = commandeIcons

  self.invoicing = invoicingIcons

  self.sale = saleIcons
  self.axletree = axletreeIcons
  self.piece = pieceIcons
  self.sterile = sterileIcons

  self.setting = settingIcons

  self.sort = 'swap_vert'
  self.excel = 'insert_chart'
  self.search = 'search'
  self.newSearch = 'youtube_searched_for'
  self.edit = 'edit'
  self.build = 'build'
  self.localsearch = 'search'
  self.export = 'file_download'
  self.delete = 'delete'
  self.add = 'add'
  self.remove = 'delete'
  self.minus = 'remove'
  self.back = 'keyboard_return'
  self.show = 'visibility'
  self.hide = 'visibility_off'
  self.validate = 'check'
  self.arrowDown = 'arrow_drop_down'
  self.arrowUp = 'arrow_drop_up'
  self.next = 'send'
  self.go = 'send'
  self.begin = 'send'
  self.create = 'create'
  self.close = 'close'
  self.date = 'today'
  self.clear = 'close'
  self.cancel = 'keyboard_return'
  self.email = 'email'
  self.save = 'save'
  self.copy = 'save'
  self.backArrow = 'arrow_back'
  self.forwardArrow = 'arrow_forward'
  self.downArrow = 'arrow_downward'
  self.upArrow = 'arrow_upward'
  self.checkbox = 'check_box_outline_blank'
  self.weight = 'build'

  self.select = (_selected) => {
    return _selected ? 'close' : 'done_all'
  }

  self.moreSearchOptions = 'zoom_in'
  self.lessSearchOptions = 'zoom_out'

  self.display = (_display) => {
    return _display ? self.hide : self.show
  }

  self.moreOptions = (_display) => {
    return _display ? self.lessSearchOptions : self.moreSearchOptions
  }

  self.choose = (_isChoose) => {
    return _isChoose ? self.edit : self.validate
  }

  self.options = 'zoom_in'
  self.setting = 'settings'
  self.settings = 'settings'

  self.menus = {
    account: 'account_circle',
    option: 'settings',
    logout: 'input',
    login: 'account_circle',
    wagonId: 'train',
  }

  self.listMenu = 'send'

  return self
}

export default icons



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/icons.resource.js